import * as types from './types'
import * as actions from './actions'
import * as getters from './getters'

const state = {
  company: false,
  companyInfos: [
    {
      title: 'La Radio',
      icon: 'microphone',
      content: '<p>Radio Corporación Calizaya - Radio RCC, es una empresa joven y Tacneña, creada un 09 de Julio del 2014, con el objetivo de ser un medio de comunicación social masiva dentro del marco democrático y respetuoso de la Base Legal de nuestro país, conforme a la Ley 28278 Ley de Radio y Televisión y su Reglamento, además del Código de Ética vigente.</p>'
    },
    {
      title: 'Nos Comprometemos',
      icon: 'handshake',
      content: '<p>Emitir una programación educativa e informativa, entretenida, innovadora y de calidad, donde se ejercite a diario una cultura democrática que contribuya a la transformación de la sociedad, y promueva el desarrollo sostenible de nuestra ciudad de Tacna y nuestro país.</p>'
    },
    {
      title: 'Nuestros Principios',
      icon: 'security',
      content: '<ul><li>La defensa de la persona humana y el respeto a su dignidad.</li><li>La libertad de expresión, de pensamiento y de opinión.</li><li>El respeto al pluralismo informativo, político, religioso, social y cultural.</li><li>La defensa del orden jurídico democrático, de los derechos humanos fundamentales y de las libertades consagradas en los tratados internacionales y en la Constitución Política del Perú.</li><li>La libertad de información veraz e imparcial.</li><li>El fomento de la educación, cultura y moral de la Nación.</li><li>La protección y formación integral de los niños y adolescentes, así como el respeto de la institución familiar.</li><li>La promoción de los valores y la identidad nacional.</li><li>La responsabilidad social de los medios de comunicación.</li><li>El respeto al honor, la buena reputación y la intimidad personal y familiar.</li><li>El respeto al derecho de rectificación.</li></ul>'
    }
  ],
  frequencies: [
    {
      name: '99.3 FM',
      status: 'Autorizado',
      locations: [
        'Gregorio Albarracin',
        'Alto de la Alianza',
        'Ciudad Nueva',
        'La Yarada',
        'Los Palos',
        'Pocollay',
        'Calana',
        'Pachia'
      ]
    },
    {
      name: '100.3 FM',
      status: 'Autorizado',
      locations: [
        'Ilabaya',
        'Toquepala',
        'Mirave',
        'Cambaya',
        'Poquera',
        'Pocollay',
        'Borogueña',
        'Chintari'
      ]
    },
    {
      name: '94.3 FM',
      status: 'Autorizado',
      locations: [
        'Locumba',
        'Quebrada Honda',
        'Valle Cinto',
        'Chaucalana',
        'Sagollo',
        'Valle de Chipe'
      ]
    },
    {
      name: '103.3 FM',
      status: 'Autorizado',
      locations: [
        'La Yarada',
        'Los Palos',
        'Boca del Río',
        'Vila Vila',
        'Puerto Grau',
        'Sama - Las Yaras',
        'Sama - Inclan',
        'Ite'
      ]
    }
  ]
}

const mutations = {
  [types.RECEIVE_COMPANY] (state, data) {
    state.company = data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/company/index.js